import { applyMiddleware, compose, createStore } from "redux";
import logger from "redux-logger";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";

import { isProduction } from "../helpers/GeneralHelper";
import TrackJSLogger from "./TrackJSLogger";

const store = (rootReducer, rootSaga, state = null) => {
	/* Redux Configuration */
	const middleware = [];
	const enhancers = [];

	/* Async Actions Middleware */
	middleware.push(thunk);

	/* TrackJS Middleware - only in production */
	/* istanbul ignore next */
	if (isProduction()) {
		middleware.push(TrackJSLogger);
	}

	/* Logger Middleware */
	/* istanbul ignore next */
	if (process.env.NODE_ENV === "development") {
		middleware.push(logger);
	}

	/* Saga Middleware */
	const sagaMonitor = null;

	const sagaMiddleware = createSagaMiddleware({ sagaMonitor });
	middleware.push(sagaMiddleware);

	/* Falls back to identity compose when the Redux DevTools extension is not installed */
	const composeEnhancers =
		(typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

	enhancers.push(applyMiddleware(...middleware));
	/* istanbul ignore next */
	if (state !== null) {
		enhancers.push(state);
	}

	const store = createStore(rootReducer, composeEnhancers(...enhancers));

	// kick off root saga
	const sagasManager = sagaMiddleware.run(rootSaga);

	return {
		store,
		sagasManager,
		sagaMiddleware,
	};
};

export default store;
